import { render } from "./InformationProcessId.vue?vue&type=template&id=cd7f8fbc&scoped=true"
import script from "./InformationProcessId.vue?vue&type=script&lang=js"
export * from "./InformationProcessId.vue?vue&type=script&lang=js"

import "./InformationProcessId.vue?vue&type=style&index=0&id=cd7f8fbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd7f8fbc"]])

export default __exports__